// extracted by mini-css-extract-plugin
module.exports = {"gulch":"gulch_gulch__1jnn-"};